var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9992 9.50229L18.4383 9.08519C19.1657 8.39413 20.3452 8.39413 21.0725 9.08519C21.8 9.77626 21.8 10.8967 21.0725 11.5877L20.6335 12.0049M17.9992 9.50229C17.9992 9.50229 18.0542 10.3886 18.8773 11.1707C19.7006 11.9527 20.6335 12.0049 20.6335 12.0049M17.9992 9.50229L13.963 13.3368C13.6895 13.5965 13.5528 13.7264 13.4353 13.8696C13.2967 14.0385 13.1778 14.2213 13.0808 14.4146C12.9986 14.5786 12.9374 14.7528 12.8151 15.1013L12.4237 16.2169L12.297 16.5778M20.6335 12.0049L16.5973 15.8394C16.3239 16.0992 16.1871 16.229 16.0364 16.3407C15.8586 16.4724 15.6662 16.5854 15.4627 16.6775C15.2901 16.7556 15.1068 16.8138 14.74 16.9299L13.5656 17.3018L13.1857 17.4221M12.297 16.5778L12.1704 16.9388C12.1102 17.1102 12.1572 17.2993 12.2917 17.4271C12.4263 17.5549 12.6253 17.5996 12.8058 17.5424L13.1857 17.4221M12.297 16.5778L13.1857 17.4221",
    stroke: "#5D5D5D",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79346 13.9653H9.16184",
    stroke: "#5D5D5D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79346 10.365H12.9512",
    stroke: "#5D5D5D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79346 17.5667H8.21449",
    stroke: "#5D5D5D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.61816 14.8679V11.2679C3.61816 7.87376 3.61816 6.17671 4.72805 5.12228C5.83795 4.06787 7.62429 4.06787 11.197 4.06787H13.0917C16.6643 4.06787 18.4508 4.06787 19.5606 5.12228M20.6705 14.8679C20.6705 18.262 20.6705 19.9591 19.5606 21.0134M19.5606 21.0134C18.4508 22.0679 16.6643 22.0679 13.0917 22.0679H11.197C7.62429 22.0679 5.83795 22.0679 4.72805 21.0134M19.5606 21.0134C20.454 20.1646 20.6282 18.8995 20.6623 16.6679",
    stroke: "#5D5D5D",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.196f5a554cfbffe27d859e670ea7ac88.svg";
export { ForwardRef as ReactComponent };